import { useTheme } from "../../context/useThemeContext";
import { useEffect, useLayoutEffect, useState } from "react";
import useMainStore from "../../stores/mainStore";
import { FaCloud } from "react-icons/fa6";
import { useGetEditor } from "../../context/useEditorContext";
import { hexToRGBA } from "../../utility/hexToRGB";

function RichTextFooter() {
    const editor = useGetEditor().editor.current;
    const { theme } = useTheme();
    const [textLength, setTextLength] = useState({
        chars: 0,
        words: 0,
    });

    // On editor update, update textLength state
    useEffect(() => {
        const handleUpdate = () => {
            setTextLength({
                chars: editor?.getText().length || 0,
                words:
                    editor
                        ?.getText()
                        .replaceAll("\n", " ")
                        .split(" ")
                        .filter((s) => s !== "" && s !== " ").length || 0,
            });
        };

        editor?.on("update", handleUpdate);
        editor?.on("focus", handleUpdate);
        // Need to wrap this in a timeout for it to run AFTER the tab switches and editor content was set
        handleUpdate();

        return () => {
            editor?.off("update", handleUpdate);
            editor?.off("focus", handleUpdate);
        };
    }, [editor?.state]);

    return (
        <div
            className="h-[34px] flex px-3 items-center text-xs gap-[6px]"
            style={{
                backgroundColor: theme.headerColor,
                color: theme.fontColor[100],
            }}
        >
            <p>{textLength.chars.toLocaleString()} chars</p>
            <div
                className="h-[14px] w-[1px] "
                style={{
                    backgroundColor: hexToRGBA(theme.fontColor[100], 0.3),
                }}
            />
            <p>{textLength.words.toLocaleString()} words</p>
            <div className="flex flex-1"></div>
            <div className="flex items-center gap-1 mx-1">
                <FaCloud size={14} className="shrink-0 mb-[1px]" />
                <p className="font-bold shrink-0 text-xs">CloudNote</p>
            </div>
        </div>
    );
}

export default RichTextFooter;
